// FILE: frontend/src/utils/audio.js
// Pure audio utility functions extracted from CoreApp

/**
 * Convert Float32 audio samples to 16-bit PCM (little-endian)
 * for sending to OpenAI Realtime API.
 */
export function floatTo16BitPCM(float32Array) {
  const buffer = new ArrayBuffer(float32Array.length * 2)
  const view = new DataView(buffer)
  for (let i = 0; i < float32Array.length; i++) {
    const s = Math.max(-1, Math.min(1, float32Array[i]))
    view.setInt16(i * 2, s < 0 ? s * 0x8000 : s * 0x7fff, true)
  }
  return buffer
}

/**
 * Downsample from any source rate to 24kHz for OpenAI.
 * On desktop Chrome the AudioContext is often 24kHz (no-op).
 * On Android/iOS it's typically 48kHz.
 * Linear interpolation is good enough for speech.
 */
export function downsampleTo24k(float32Array, sourceSampleRate) {
  if (sourceSampleRate === 24000) return float32Array
  const ratio = sourceSampleRate / 24000
  const newLength = Math.floor(float32Array.length / ratio)
  const result = new Float32Array(newLength)
  for (let i = 0; i < newLength; i++) {
    const srcIndex = i * ratio
    const srcFloor = Math.floor(srcIndex)
    const srcCeil = Math.min(srcFloor + 1, float32Array.length - 1)
    const frac = srcIndex - srcFloor
    result[i] = float32Array[srcFloor] * (1 - frac) + float32Array[srcCeil] * frac
  }
  return result
}

/**
 * Generate a unique session ID for WebSocket connections.
 */
export function generateSessionId() {
  return 'session_' + Math.random().toString(36).substring(2, 15)
}
